import { RolesEnum } from "../enums/roles.enum";

export class ApplicationUserModel {
    nameid?: string;
    unique_name?: string;
    given_name?: string;
    family_name?: string;
    email?: string;
    asvzId?: number;
    imId?: number;
    roles?: Array<string>;

    public isAuthenticated() {
        return (this.nameid != null);
    }

    public isAdmin(): boolean {
        if (this.hasRole(RolesEnum.Admin)) return true;
        return false;
    }

    public isOffice(): boolean {
        if (this.hasRole(RolesEnum.Office)) return true;
        return false;
    }


    public isOfficeOrAdmin(): boolean {
        if (this.isAdmin()) return true;
        if (this.isOffice()) return true;
        return false;
    }

    private hasRole(role: RolesEnum): boolean {
        if (!this.roles) return false;

        const target = role.toString().toLowerCase();
        return this.roles.some(r => r.toLowerCase() === target);
    }
}

